export const OverflowHiddenController = {
  enable() {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.overscrollBehaviorY = 'contain';
  },

  disable() {
    const scrollY = Math.abs(parseInt(document.body.style.top || '0'));
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.overscrollBehaviorY = 'auto';
    window.scrollTo(0, scrollY);
  },
} as const;
